import React from "react";
import project_1 from "../assets/project/project_1.png"
import project_2 from "../assets/project/project_2.png"
import project_3 from "../assets/project/project_3.png"
import project_4 from "../assets/project/project_4.png"
import project_5 from "../assets/project/project_5.png"
import project_6 from "../assets/project/project_6.png"
import project_7 from "../assets/project/project_7.png"
import project_8 from "../assets/project/project_8.png"
import project_9 from "../assets/project/project_9.png"
import "./style/catalogueProjetcts.css"
import Slider from "react-slick";

class CatalogueProjetcts extends React.Component {

    render() {
        var settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 1,
            initialSlide: 0,
            arrows: false,
            autoplay: true,
            cssEase: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
            responsive: [
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
         
        }
            
        return (
            <div>
                <div className="background">
                    {/*Sliderrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr*/}
                    <div className="slideCatalogue">
                        <Slider {...settings}>
                        <div>
                            <img style={{ width: "100%", height: 250}} src={project_1} alt="" />
                        </div>
                        <div>
                            <img style={{ width: "100%", height: 250}} src={project_2} alt="" />     
                        </div>
                        <div>
                            <img style={{ width: "100%", height: 250}} src={project_3} alt="" /> 
                        </div>
                        <div>
                            <img style={{ width: "100%", height: 250}} src={project_4} alt="" /> 
                        </div>
                        <div>
                            <img style={{ width: "100%", height: 250}} src={project_5} alt="" /> 
                        </div>
                        <div>
                            <img style={{ width: "100%", height: 250}} src={project_6} alt="" /> 
                        </div>
                        <div>
                            <img style={{ width: "100%", height: 250}} src={project_7} alt="" /> 
                        </div>
                        </Slider>
                    </div>
                    
                    <div style={{ width: "1000px", margin: "0 auto", marginTop: "-75px" }} className="section">
                        <div style={{ width: "325px", height: "200px" }} className="col grid_1_of_9">
                            <img style={{ width: "100%" }} src={project_1} alt="" />
                        </div>
                        <div style={{ width: "325px", height: "200px" }} className="col grid_1_of_9">
                            <img style={{ width: "100%" }} src={project_2} alt="" />
                        </div>

                        <div style={{ width: "325px", height: "200px" }} className="col grid_1_of_9">
                            <img style={{ width: "100%" }} src={project_3} alt="" />
                        </div>

                        <div style={{ width: "325px", height: "200px" }} className="col grid_1_of_9">
                            <img style={{ width: "100%" }} src={project_4} alt="" />
                        </div>

                        <div style={{ width: "325px", height: "200px" }} className="col grid_1_of_9">
                            <img style={{ width: "100%" }} src={project_5} alt="" />
                        </div>

                        <div style={{ width: "325px", height: "200px" }} className="col grid_1_of_9">
                            <img style={{ width: "100%" }} src={project_6} alt="" />
                        </div>

                        <div style={{ width: "325px", height: "200px" }} className="col grid_1_of_9">
                            <img style={{ width: "100%" }} src={project_7} alt="" />
                        </div>

                        <div style={{ width: "325px", height: "200px" }} className="col grid_1_of_9">
                            <img style={{ width: "100%" }} src={project_8} alt="" />
                        </div>

                        <div style={{ width: "325px", height: "200px" }} className="col grid_1_of_9">
                            <img style={{ width: "100%" }} src={project_9} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default CatalogueProjetcts;






// WEBPACK FOOTER //
// ./src/home/catalogueProjetcts.js